// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3T8d0","label":"Completed_label__3_uC4"};